import { ref, computed } from 'vue'
import { BaseRoleService } from '@/services/roles/BaseRoleService'

export const useRoleData = (role) => {
  const roleData = ref({})
  const loading = ref(false)
  const error = ref(null)
  
  let roleService = null

  const initializeService = () => {
    if (!roleService) {
      roleService = new BaseRoleService(role)
    }
  }

  const loadRoleData = async (params = {}) => {
    try {
      loading.value = true
      error.value = null
      initializeService()
      
      const data = await roleService.getDashboardData(params)
      roleData.value = data
      
      return data
    } catch (err) {
      error.value = err.message || 'Error cargando datos del rol'
      console.warn('⚠️ Error en useRoleData:', err.message)
      
      const unavailableData = {
        role: role,
        status: 'NOT_AVAILABLE',
        message: 'Datos del rol no disponibles desde backend real',
        data: null,
        timestamp: new Date().toISOString()
      }
      
      roleData.value = unavailableData
      return unavailableData
    } finally {
      loading.value = false
    }
  }

  const refreshData = async (params = {}) => {
    return await loadRoleData(params)
  }

  const isLoading = computed(() => loading.value)
  const hasError = computed(() => !!error.value)
  const hasData = computed(() => Object.keys(roleData.value).length > 0)

  return {
    roleData,
    loading: isLoading,
    error,
    hasError,
    hasData,
    loadRoleData,
    refreshData
  }
}
